import { useEffect } from 'react';
import PopUp from '../Popup';
import cn from 'classnames';
import { useStore } from '@/store/main';

const PopupWrapper = ({ colorStep, colorButton, isOpen, showSteps, steps, text }) => {
  const [setIsPopupOpen] = useStore((state) => [state.setIsPopupOpen]);

  useEffect(() => {
    const id = setTimeout(() => {
      setIsPopupOpen(isOpen);
    }, 500);
    return () => clearTimeout(id);
  }, [isOpen, setIsPopupOpen]);

  const close = () => {
    window.location.reload();
  };

  return (
    <div
      className={cn(
        'fixed w-screen h-screen z-[1000] top-20 sm:top-0 left-1/2 -translate-x-1/2 duration-50',
        {
          'opacity-0 pointer-events-none': !isOpen,
          'opacity-100': isOpen
        }
      )}
    >
      <button
        type="button"
        aria-label="Cerrar"
        className="absolute top-0 left-0 w-full h-full bg-white-1 bg-opacity-80"
        onClick={close}
      />
      <div
        className={cn(
          'absolute left-0 sm:left-1/2 top-1/2 -translate-y-1/2 sm:-translate-x-1/2 mx-10 sm:mx-0 duration-50',
          {
            'scale-90 opacity-0 pointer-events-none': !isOpen,
            'scale-100 delay-100': isOpen
          }
        )}
      >
        <PopUp
          close={close}
          colorStep={colorStep}
          colorButton={colorButton}
          showSteps={showSteps}
          steps={steps}
          text={text}
        />
      </div>
    </div>
  );
};
export default PopupWrapper;
